function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/no-multi-comp */
/* eslint-disable max-lines */
import React, { useEffect, useState, useRef } from 'react';
import { isString } from 'lodash';
import { t, Translate } from "../../../../I18N";
import { debounce } from "../../../../utils";
import { Label } from "../Label";
import { Checkbox } from "../Checkbox";
import { MultiselectListButtonItem } from "./MultiselectListButtonItem";
import { MultiselectListGroup } from "./MultiselectListGroup";
import { InputField, RadioSelect } from '..';






























const WrapChild = ({ children }) =>
isString(children) ? /*#__PURE__*/_jsx(Translate, {}, void 0, children) : children;

const defaultSearch = (search, items) => {
  const filtered = [];

  const labelIncludesSearch = (_label) => {
    const a = _label.
    toLowerCase().
    normalize('NFD').
    replace(/\p{Diacritic}/gu, '');
    const b = search.
    toLowerCase().
    normalize('NFD').
    replace(/\p{Diacritic}/gu, '');
    return a.includes(b);
  };

  items === null || items === void 0 ? void 0 : items.forEach((item) => {var _item$items;
    const matchesSearch = !search || labelIncludesSearch(item.searchLabel);

    const containsChildrenMatchingSearch =
    !search || ((_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.some((childItem) => labelIncludesSearch(childItem.searchLabel)));

    if (matchesSearch || containsChildrenMatchingSearch) {var _item$items2;
      filtered.push(_objectSpread(_objectSpread({},
      item), {}, {
        items: (_item$items2 = item.items) === null || _item$items2 === void 0 ? void 0 : _item$items2.filter((childItem) =>
        childItem.searchLabel.toLowerCase().includes(search.toLowerCase())
        ) })
      );
    }
  });

  return filtered;
};

// eslint-disable-next-line max-statements
const MultiselectList = ({
  items,
  onChange,
  onSearch,
  className = '',
  label,
  hasErrors,
  selectedValues,
  checkboxes = false,
  foldableGroups = false,
  singleSelect = false,
  allowSelelectAll = false,
  startOnSelected = false,
  search = '',
  suggestions = false,
  hideFilters = false,
  itemClassName,
  itemContainerClassName,
  noItems = /*#__PURE__*/_jsx(Translate, {}, void 0, "No items available")
}) => {
  const [selections, setSelections] = useState(selectedValues || []);
  const [availableItems, setAvailableItems] = useState(items);
  const [showAll, setShowAll] = useState(!(startOnSelected && selections.length));
  const [searchTerm, setSearchTerm] = useState(search);
  const [isDirty, setIsDirty] = useState(false);
  const [openGroups, setOpenGroups] = useState([]);
  const [selectedOrSuggestedItems, setSelectedOrSuggestedItems] = useState(
    new Set(selectedValues)
  );
  const optionsRef = useRef(null);

  const debouncedSearch = useRef(onSearch ? debounce(onSearch, 300) : undefined).current;

  useEffect(() => {
    setAvailableItems(items);
  }, [items]);

  useEffect(() => {
    if (selectedValues) {
      setSelections(selectedValues);
    }
  }, [selectedValues]);

  useEffect(() => {
    setSearchTerm(search);
    setIsDirty(true);
    return () => {
      setIsDirty(false);
      setSearchTerm('');
    };
  }, [search]);

  useEffect(() => {
    if (isDirty && debouncedSearch) {
      debouncedSearch(searchTerm);
    }
  }, [debouncedSearch, isDirty, searchTerm]);

  useEffect(() => {
    if (startOnSelected) {
      const groupsToExpand = availableItems === null || availableItems === void 0 ? void 0 : availableItems.
      filter((item) => {var _item$items3;return (_item$items3 = item.items) === null || _item$items3 === void 0 ? void 0 : _item$items3.some((childItem) => selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.includes(childItem.value));}).
      map((item) => item.value);

      setOpenGroups(groupsToExpand);
    }
  }, [availableItems, selectedValues, startOnSelected]);

  useEffect(() => {
    const newSet = new Set(selections);

    availableItems === null || availableItems === void 0 ? void 0 : availableItems.forEach((item) => {
      if (item.suggested) {
        newSet.add(item.value);
      }

      if (item.items) {
        item.items.forEach((subItem) => {
          if (subItem.suggested) {
            newSet.add(subItem.value);
          }
        });
      }
    });

    setSelectedOrSuggestedItems(newSet);
  }, [availableItems, selections]);

  const handleSelect = (_value) => {
    let newValues;
    if (singleSelect) {
      newValues = selections.includes(_value) ? [] : [_value];
    } else {
      newValues = selections.includes(_value) ?
      selections.filter((item) => item !== _value) :
      [...selections, _value];
    }

    setSelections(newValues);
    if (onChange) onChange(newValues);
  };

  const handleSelectAll = () => {
    const allValues = [];

    availableItems === null || availableItems === void 0 ? void 0 : availableItems.forEach((item) => {var _item$items4;
      if ((_item$items4 = item.items) !== null && _item$items4 !== void 0 && _item$items4.length) {var _item$items5;
        (_item$items5 = item.items) === null || _item$items5 === void 0 ? void 0 : _item$items5.forEach((subItem) => allValues.push(subItem.value));
      } else {
        allValues.push(item.value);
      }
    });

    setSelections(allValues);
    if (onChange) onChange(allValues);
  };

  const handleGroupToggle = (groupKey) => {
    if (openGroups !== null && openGroups !== void 0 && openGroups.includes(groupKey)) {
      setOpenGroups(openGroups.filter((group) => group !== groupKey));
    } else {
      setOpenGroups([...(openGroups || []), groupKey]);
    }
  };

  const renderButtonItem = (item) => {
    if (item.items) {
      return renderGroup(item);
    }

    const selected = selections.includes(item.value);

    return (/*#__PURE__*/
      _jsx(MultiselectListButtonItem, {

        item: item,
        selected: selected,
        onClick: () => handleSelect(item.value),
        itemClassName: itemClassName }, item.value
      ));

  };

  const renderCheckboxItem = (item) => {
    if (item.items) {
      return renderGroup(item);
    }
    const selected = selections.includes(item.value);
    return (/*#__PURE__*/
      _jsx("li", {

        className: `${!selected && searchTerm && !showAll ? 'opacity-70' : ''} ${itemClassName !== null && itemClassName !== void 0 ? itemClassName : ' rounded-lg mb-2'} ` }, item.value, /*#__PURE__*/

      _jsx(Checkbox, {
        name: item.value,
        label: item.label,
        checked: selected,
        onChange: () => handleSelect(item.value) }
      )
      ));

  };

  const renderItem = (item) => {var _item$items6;
    const itemHasSelectedChildren = (_item$items6 = item.items) === null || _item$items6 === void 0 ? void 0 : _item$items6.some(
      (childItem) => selections.includes(childItem.value) || childItem.suggested
    );

    if (
    !showAll &&
    !selections.includes(item.value) &&
    !item.suggested &&
    !itemHasSelectedChildren)
    {
      return null;
    }

    return checkboxes ? renderCheckboxItem(item) : renderButtonItem(item);
  };

  const renderGroup = (group) => {var _group$items;
    const isOpen = openGroups === null || openGroups === void 0 ? void 0 : openGroups.includes(group.value);

    return (/*#__PURE__*/
      _jsx(MultiselectListGroup, {

        label: group.label,
        isOpen: !!isOpen,
        foldable: foldableGroups,
        onClick: () => handleGroupToggle(group.value),
        itemContainerClassName: itemContainerClassName,
        itemClassName: itemClassName }, group.value, (_group$items =

      group.items) === null || _group$items === void 0 ? void 0 : _group$items.map(renderItem)
      ));

  };

  const renderSelectedLabel = () => {
    if (suggestions) {
      return (/*#__PURE__*/
        _jsx("span", { className: "flex gap-1" }, void 0, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Selected or suggested"),
        selectedOrSuggestedItems.size ? `(${selectedOrSuggestedItems.size})` : ''
        ));

    }

    return (/*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Selected"), " ", selections.length ? `(${selections.length})` : ''
      ));

  };

  return (/*#__PURE__*/
    _jsx("div", { className: `flex flex-col h-full ${className}` }, void 0, /*#__PURE__*/
    _jsx("div", { className: "w-full mb-2 bg-white" }, void 0, /*#__PURE__*/
    _jsx(Label, { htmlFor: "search-multiselect", hideLabel: !label, hasErrors: Boolean(hasErrors) }, void 0,
    label
    ), /*#__PURE__*/
    _jsx(InputField, {
      id: "search-multiselect",
      label: "search-multiselect",
      hideLabel: true,
      placeholder: t('System', 'Search', null, false),
      value: searchTerm,
      clearFieldAction: () => {
        setSearchTerm('');
      },
      onChange: (e) => {
        setSearchTerm(e.currentTarget.value);
        setIsDirty(true);
      } }
    ),
    !hideFilters && /*#__PURE__*/
    _jsx("div", { className: "flex mx-1 my-4 flex-nowrap", "data-testid": "multiselectlist-filters" }, void 0, /*#__PURE__*/
    _jsx(RadioSelect, {
      name: "filter",
      orientation: "horizontal",
      options: [
      {
        label: /*#__PURE__*/_jsx(Translate, { "data-testid": "multiselectlist-show-all" }, void 0, "All"),
        value: 'true',
        defaultChecked: !startOnSelected
      },
      {
        label: renderSelectedLabel(),
        value: 'false',
        disabled: selectedOrSuggestedItems.size === 0,
        defaultChecked: startOnSelected
      }],

      onChange: (e) => setShowAll(e.currentTarget.value === 'true'),
      className: "flex-grow" }
    ),
    allowSelelectAll && /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "text-gray-400 underline",
      onClick: () => handleSelectAll() }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Select all")
    )

    )

    ),

    (availableItems === null || availableItems === void 0 ? void 0 : availableItems.length) === 0 && /*#__PURE__*/
    _jsx("div", { className: "flex grow w-full h-full justify-center items-start" }, void 0, /*#__PURE__*/
    _jsx(WrapChild, {}, void 0, noItems)
    ), /*#__PURE__*/

    React.createElement("ul", {
      className: `${itemContainerClassName !== null && itemContainerClassName !== void 0 ? itemContainerClassName : ' w-full grow px-2 pt-2 overflow-y-auto'}`,
      ref: optionsRef },

    availableItems === null || availableItems === void 0 ? void 0 : availableItems.map(renderItem)
    )
    ));

};
export { MultiselectList, defaultSearch };